import { Toaster } from 'sonner';

// Shared by the app shell and component previews so placement cannot drift.
export default function AppToaster() {
  return (
    <Toaster
      position="top-right"
      richColors
      duration={2000}
      visibleToasts={1}
      expand={false}
      toastOptions={{
        style: {
          background: '#131822',
          border: '1px solid rgba(255,255,255,0.1)',
          color: '#fff',
        },
      }}
    />
  );
}
